<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <!-- Search Bar -->

        <v-layout row wrap align-center class="mt-4 mb-4" style="gap: 10px">
          <v-flex sm3 style="flex: 0 0 auto; min-width: 200px">
            <v-select
              v-model="searchBy"
              :items="[
                { text: 'Org Code', value: 'orgCode' },
                // { text: 'Name', value: 'name' },
                // { text: 'Type', value: 'type' },
                // { text: 'Request Type', value: 'requestType' },
                // { text: 'Status', value: 'status' },
              ]"
              item-text="text"
              item-value="value"
              outlined
              dense
            ></v-select>
          </v-flex>
          <v-flex sm4 style="flex: 1; min-width: 250px">
            <v-text-field
              v-model="searchTermUpper"
              placeholder="Search"
              outlined
              dense
            ></v-text-field>
          </v-flex>
          <v-flex sm2 style="flex: 0 0 auto; min-width: 150px">
            <v-btn
              color="success"
              class="white--text"
              block
              style="height: 40px"
             
              @click="search"
            >
              Search
            </v-btn>
          </v-flex>
        </v-layout>

        <!-- Data Table -->
        <v-data-table
          :headers="[
            { text: 'Name', value: 'organisationName' },
            { text: 'Org Code', value: 'organisationCode' },
            { text: 'Organisation Type', value: 'organisationTypeName' },
            { text: 'Request Type', value: 'actionType' },
            { text: 'Status', value: 'statusName' },
            {
              text: 'Action',
              value: 'actions',
              sortable: false,
              align: 'center',
            },
          ]"
          :items="paginatedRows"
          :options.sync="tableOptions"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-0"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.organisationName }}</td>
              <td>{{ item.organisationCode }}</td>
              <td>{{ item.organisationTypeName }}</td>
              <td>{{ item.actionType }}</td>
              <td>
                <v-chip
                  :color="getStatusColor(item.statusName)"
                  text-color="white"
                  small
                >
                  {{ formatStatus(item.statusName) }}
                </v-chip>
              </td>
              <td class="text-center">
                <v-icon small class="cursor-pointer" @click="view(item)">
                  fa-eye
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>

        <!-- Dialog -->
        <v-dialog v-model="dialog" max-width="1200px" scrollable :loading="dialogLoading" :persistent="processingApprove" :close-on-backdrop-click="!processingApprove" :close-on-esc="!processingApprove">
          <v-card>
            <!-- Back Button -->
              <v-toolbar color="white" flat class="mb-4">
              <v-btn icon @click="dialog = false" color="success" :disabled="processingApprove">
                <v-icon>fa-arrow-left</v-icon>
              </v-btn>
              <span class="ml-2">Back</span>
            </v-toolbar>

            <v-card-text>
              <!-- Organization Header (always visible) -->
              <v-card
                class="mb-4"
                style="border: 2px solid #7bc243; border-radius: 8px"
              >
                <v-card-text class="pa-4">
                  <h3 class="mb-0">
                    {{ paginatedRows.find(r => r.id === selectedRowId)?.organisationName }}: {{ paginatedRows.find(r => r.id === selectedRowId)?.organisationCode }}
                  </h3>
                </v-card-text>
              </v-card>

              <!-- Loading Indicator (for API data) -->
              <v-layout v-if="dialogLoading" align-center justify-center class="pa-5">
                <v-progress-circular indeterminate color="success" :size="50"></v-progress-circular>
              </v-layout>

              <!-- Details Changing Table (shown when data loaded) -->
              <v-card v-else class="mb-4">
                <v-simple-table>
                  <thead>
                    <tr style="background-color: #e8eef5">
                      <th>Details changing</th>
                      <th>From</th>
                      <th>To</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(change, index) in selectedRow" :key="index">
                      <td>{{ change.changedFields }}</td>
                      <td>{{ change.oldValue }}</td>
                      <td>{{ change.newValue }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>

              <!-- Maker Details (shown when data loaded) -->
              <v-card v-if="!dialogLoading" class="mb-4">
                <v-card-title class="text-subtitle1"
                  >Maker Details</v-card-title
                >
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <div class="mb-2">
                        <strong>Maker</strong>
                      </div>
                      <div
                        class="pa-2"
                        style="background-color: #f5f5f5; border-radius: 4px"
                      >
                        {{ selectedRow.length > 0 ? selectedRow[0].changedBy : '' }}
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <div class="mb-2">
                        <strong>Date</strong>
                      </div>
                      <div
                        class="pa-2"
                        style="background-color: #f5f5f5; border-radius: 4px"
                      >
                        {{ formatChangeDate(selectedRow.length > 0 ? selectedRow[0].changeDate : null) }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <!-- Action Buttons (shown when data loaded) -->
              <!-- <v-layout v-if="!dialogLoading" row justify-space-around class="mt-6 mb-6">
                <v-flex xs12 sm4>
                  <v-btn outlined color="success" block @click="reject">
                    Reject
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm4 class="pl-2">
                  <v-btn
                      color="success"
                      class="white--text"
                      block
                      @click="approve()"
                      :loading="processingApprove"
                      :disabled="processingApprove"
                    >
                      Approve
                    </v-btn>
                </v-flex>
              </v-layout> -->
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
export default {
  name: "OrganizationUpdateRequests",
  data() {
    return {
      searchBy: "orgCode",
      searchTerm: "",
     
      dialog: false,
      selectedRow: [],
      selectedRowId: null,
      processingApprove: false,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      paginatedRows: [],
      totalItems: 0,
      loading: false,
      dialogLoading: false,
      request: '',
      action: '',
			messsage: ''
    };
  },
  computed: {
    filteredRows() {
      if (!this.searchTerm) return this.paginatedRows;
      const term = this.searchTerm.toLowerCase();
      return this.paginatedRows.filter((r) =>
        String(r[this.searchBy]).toLowerCase().includes(term)
      );
    },
    
		searchTermUpper: {
		  get() {
			return this.searchTerm;
		  },
		  set(value) {
			this.searchTerm = value.toUpperCase();
		  }
		}
  },
  
  watch: {
    tableOptions: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
    searchTerm(newVal) {
      // When search field is cleared, reset to page 1 and load all data
      if (!newVal || newVal.trim() === '') {
        this.tableOptions.page = 1;
        this.fetchData();
      }
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {

   
  	sendRequest (request) {
			var url = config.serverURI + '/organization/update/' + request
			axios.post(url, this.selectedRow)
				.then(response => {
					this.snackbar = true
					if (response.data.error) {
						this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
					} else {
						this.organizations = this.getOrganizationsToBeApproved(this.currentPage)
						this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
					}
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
		},
  //   fetchData() {
  //     this.loading = true;
  //     let pageNumber = Math.max(0, this.tableOptions.page - 1); // Backend uses 0-indexed pages
  //     let pageSize = this.tableOptions.itemsPerPage;

  //     // Vuetify uses a non-positive itemsPerPage (often -1) for "All" selection.
  //     // When that happens request all items from the backend by using totalItems
  //     // (if known) or a large fallback; and reset to first page.
  //     if (!pageSize || pageSize < 1) {
  //       pageNumber = 0;
  //       pageSize = this.totalItems && this.totalItems > 0 ? this.totalItems : 1000000;
  //     }

  //     var url =
  //       config.serverURI +
  // "/organization/searchOrganisation?requestType=ALL&page=" +
  // pageNumber +
  // "&size=" +
  // pageSize +
  // "&searchTerm=" +
  // encodeURIComponent(this.searchTerm || '');

  //     axios
  //       .get(url)
  //       .then((response) => {
  //         this.loading = false;

  //         if (response.status !== 200) {
  //           this.$store.dispatch("alert/displayAlert", {
  //             snackbar: true,
  //             color: "error",
  //             message: response.data.message,
  //           });
  //           return;
  //         }

  //         // Map API response data to component
  //         this.paginatedRows = response.data.data || response.data.content || [];
  //         this.totalItems = response.data.page?.totalElements || 0;

  //         console.log("Data loaded successfully:", this.paginatedRows);
  //       })
  //       .catch((error) => {
  //         this.loading = false;
  //         console.error("Error fetching data:", error);
  //         this.$store.dispatch("alert/displayAlert", {
  //           snackbar: true,
  //           color: "error",
  //           message: error.response?.data?.message || "Error occurred",
  //         });
  //       });
  //   },


     fetchData() {
      this.loading = true;
      let pageNumber = Math.max(0, this.tableOptions.page - 1); // Backend uses 0-indexed pages
      let pageSize = this.tableOptions.itemsPerPage;

      // Vuetify uses a non-positive itemsPerPage (often -1) for "All" selection.
      // When that happens request all items from the backend by using totalItems
      // (if known) or a large fallback; and reset to first page.
      if (!pageSize || pageSize < 1) {
        pageNumber = 0;
        pageSize = this.totalItems && this.totalItems > 0 ? this.totalItems : 1000000;
      }

      var url =
        config.serverURI +
        "/organization/getAllRequests?requestType=ALL&page=" +
        pageNumber +
        "&size=" +
        pageSize +
        "&query=" +
        this.searchTerm;

      axios
        .get(url)
        .then((response) => {
          this.loading = false;

          if (response.status !== 200) {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
            return;
          }

          // Map API response data to component
          this.paginatedRows = response.data.data || response.data.content || [];
          this.totalItems = response.data.page?.totalElements || 0;

          console.log("Data loaded successfully:", this.paginatedRows);
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error fetching data:", error);
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response?.data?.message || "Error occurred",
          });
        });
    },
    search() {
      // If search term is empty, fetch all data
      if (!this.searchTerm || this.searchTerm.trim() === '') {
        this.tableOptions.page = 1;
        this.fetchData();
        return;
      }

      this.loading = true;
      let pageNumber = Math.max(0, this.tableOptions.page - 1); // Backend uses 0-indexed pages
      let pageSize = this.tableOptions.itemsPerPage;
      if (!pageSize || pageSize < 1) {
        pageNumber = 0;
        pageSize = this.totalItems && this.totalItems > 0 ? this.totalItems : 1000000;
      }

      
           const url =
  config.serverURI +
  "/organization/searchOrganisation?requestType=ALL&page=" +
  pageNumber +
  "&size=" +
  pageSize +
  "&searchTerm=" +
  encodeURIComponent(this.searchTerm || '');

      axios
        .get(url)
        .then((response) => {
          this.loading = false;

          if (response.status !== 200) {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
            return;
          }

          // Map API response data to component
          this.paginatedRows = response.data.data || response.data.content || [];
          this.totalItems = response.data.page?.totalElements || 0;

          console.log("Data loaded successfully:", this.paginatedRows);
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error fetching data:", error);
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response?.data?.message || "Error occurred",
          });
        });
    },
   
    formatChangeDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
     
    view(row) {
      console.log("Viewing row:", row);
      this.selectedRowId = row.id;
      this.dialog = true;
      this.dialogLoading = true;
      const url = config.serverURI + `/organization/organisationchanges?id=${encodeURIComponent(row.id)}`
      
      axios.get(url)
        .then(response => {
          this.selectedRow = response.data;
          this.dialogLoading = false;
        })
        .catch(error => {
          this.dialogLoading = false;
          this.$store.dispatch('alert/displayAlert', {
            snackbar: true,
            color: 'error',
            message: error.response?.data?.message || 'Error fetching request details'
          });
        });
    },
    approve() {
      // API call to approve
      console.log("Approved:", this.selectedRow);
      const organisationId = this.selectedRow.length > 0 ? this.selectedRow[0].organisationId : null;
      if (!organisationId) {
        this.$store.dispatch('alert/displayAlert', {
          snackbar: true,
          color: 'error',
          message: 'Unable to approve: Missing organisation ID'
        });
        return;
      }

      this.processingApprove = true;
      const url = config.serverURI + `/organization/update/approve/${organisationId}`;
      axios.post(url)
        .then(response => {
          this.$store.dispatch('alert/displayAlert', {
            snackbar: true,
            color: 'primary',
            message: response.data.message || 'Request approved successfully'
          });
          this.dialog = false;
          this.fetchData(); // Refresh the table
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', {
            snackbar: true,
            color: 'error',
            message: error.response?.data?.message || 'Error approving request'
          });
        })
        .finally(() => {
          this.processingApprove = false;
        });
    },
    reject() {
      // API call to reject/decline
      console.log("Rejected:", this.selectedRow);
      const auditId = this.selectedRow.length > 0 ? this.selectedRow[0].auditId : null;
      if (!auditId) {
        this.$store.dispatch('alert/displayAlert', {
          snackbar: true,
          color: 'error',
          message: 'Unable to reject: Missing audit ID'
        });
        return;
      }
      const url = config.serverURI + `/organization/update/decline/${auditId}`;
      axios.post(url)
        .then(response => {
          this.$store.dispatch('alert/displayAlert', {
            snackbar: true,
            color: 'primary',
            message: response.data.message || 'Request declined successfully'
          });
          this.dialog = false;
          this.fetchData(); // Refresh the table
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', {
            snackbar: true,
            color: 'error',
            message: error.response?.data?.message || 'Error declining request'
          });
        });
    },
    getStatusColor(status) {
      if (!status) return "#999";
      const statusLower = status.toLowerCase();
      if (statusLower.includes("pending")) return "#ff9800"; // Orange
      if (statusLower.includes("approved") || statusLower.includes("completed")) return "#4caf50"; // Green
      if (statusLower.includes("rejected") || statusLower.includes("declined")) return "#f44336"; // Red
      return "#2196f3"; // Blue default
    },
 
	formatStatus(status) {
  if (!status) return "";

  return status
    .replace(/_/g, " ")          // handle underscores
    .toLowerCase()               // normalize case
    .split(" ")                  // split on spaces
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

  },
};
</script>

<style scoped>
/* ===== Page layout ===== */
.v-card {
  border-radius: 8px;
}

.v-card__title {
  font-weight: 600;
  font-size: 18px;
}

.v-card__text {
  padding-top: 8px;
}

/* ===== Search bar ===== */
.v-text-field input {
  font-size: 14px;
}

.v-text-field .v-label {
  font-size: 13px;
}

/* ===== Data table ===== */
.v-data-table {
  border-radius: 8px;
}

.v-data-table thead th {
  font-weight: 600;
  font-size: 13px;
  color: #555;
  background-color: #f5f7f8;
}

.v-data-table tbody td {
  font-size: 13px;
  color: #333;
}

.v-data-table tbody tr:hover {
  background-color: #f9fbfa;
}

/* ===== Status styling ===== */
.v-chip {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.5px;
}

/* ===== Action menu ===== */
.actions {
  min-width: 32px;
}

.v-list-item__title {
  font-size: 13px;
}

/* ===== Dialog ===== */
.v-dialog .v-card {
  border-radius: 10px;
}

.v-dialog .headline {
  font-size: 18px;
  font-weight: 600;
}

/* ===== Form fields (readonly look) ===== */
.v-text-field input[readonly] {
  background-color: #f8f9fa;
}

/* ===== Broker table ===== */
.details-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.details-table th {
  text-align: left;
  background: #f5f7f8;
  padding: 8px;
  font-weight: 600;
}

.details-table td {
  padding: 8px;
  border-bottom: 1px solid #eee;
}

/* ===== Pagination ===== */
.paginationtext {
  font-size: 13px;
  color: #666;
}

/* ===== Buttons ===== */
.v-btn.primary {
  background-color: #004d3d !important;
}

.v-btn.secondary {
  background-color: #e0e0e0 !important;
  color: #333 !important;
}
</style>
